import React, { useState } from "react";
import IconButton from "@material-ui/core/IconButton";
import Menu from "@material-ui/core/Menu";
import { useAnalyticsProvider } from "@oss/components";
import MenuIcon from "@material-ui/icons/Menu";
import OSSAppDropdown from "../OSSAppDropdown/OSSAppDropdown";

const OSSAppsMenu = ({ user }) => {
  const setTrackerData = useAnalyticsProvider();
  const [appsEl, setAppsEl] = useState(null);
  const open = Boolean(appsEl);
  const id = open ? "user-apps-menu" : undefined;

  const trackAppIconClick = label => {
    setTrackerData({
      method: "event",
      category: "Global Header",
      action: "App Icon Click",
      label: `${label} app menu navigation`
    });
  };

  const handleUserMenuClose = () => {
    setAppsEl(null);
  };

  const handleUserMenuClick = event => {
    setTrackerData({
      method: "event",
      category: "Global Header",
      action: "App menu open"
    });
    setAppsEl(event.currentTarget);
  };

  return (
    <>
      <IconButton
        id="user-apps"
        aria-owns={appsEl ? "user-apps-menu" : null}
        aria-haspopup="true"
        aria-label="User Applications Menu"
        onClick={handleUserMenuClick}
      >
        <MenuIcon />
      </IconButton>
      <Menu
        id={id}
        open={open}
        anchorEl={appsEl}
        onClose={handleUserMenuClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right"
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right"
        }}
        getContentAnchorEl={null}
      >
        <OSSAppDropdown closeHandler={handleUserMenuClose} user={user} />
      </Menu>
    </>
  );
};

export default OSSAppsMenu;
